module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (143).dde5e7ce.jpg";